<template>
  <header
    ref="header"
    class="header"
    :class="{
      'header-white-variant': headerScrollVariant,
      'header-scroll': scrollVariant && !grayVariant,
      'header-white-variant gray-scroll-variant': grayScrollVariant,
      'header-white-variant gray-variant': grayVariant,
    }"
  >
    <div class="container">
      <nuxt-link
        to="/"
        aria-label="Proxify homepage"
        @click="closeMenuOnNavigatingSameScreen('index')"
      >
        <LogoIcon
          :color="darkIcon ? 'dark' : 'white'"
          class="logo logo-white"
        />
      </nuxt-link>
      <div class="mobile-menu">
        <ApplyButton
          cta-section="top-nav"
          :page-name="pageName"
          class="btn btn-apply"
        />
        <CrossIcon
          v-if="mobileMenuOpened"
          class="cross-icon"
          @click="toggleMenu"
        />
        <MenuIcon
          v-else
          class="menu-icon"
          @click="toggleMenu"
        />
      </div>
      <nav :class="{ 'nav-opened': mobileMenuOpened }">
        <ul>
          <li class="menu-title">Menu</li>
          <li>
            <nuxt-link
              aria-label="How it works"
              to="/how-it-works"
              class="link page-link"
              @click="closeMenuOnNavigatingSameScreen('how-it-works')"
            >
              How it works
            </nuxt-link>
          </li>
          <li>
            <nuxt-link
              aria-label="Jobs"
              to="/jobs"
              class="link page-link jobs"
              @click="closeMenuOnNavigatingSameScreen('jobs')"
            >
              Jobs
            </nuxt-link>
          </li>
          <li>
            <ApplyButton
              cta-section="top-nav"
              :page-name="pageName"
              class="proxify-btn proxify-btn-white proxify-btn-no-icon"
            />
          </li>
          <li>
            <a
              aria-label="Login"
              href="https://app.proxify.io/login"
              class="link login-link"
              @click="onLoginClick"
            >
              LOG IN
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </header>
</template>

<script>
import ApplyButton from '~/components/Common/ApplyButton/ApplyButton.vue';
import LogoIcon from '~/components/Common/Svg/LogoIcon.vue';
import MenuIcon from '~/components/Common/Svg/MenuIcon.vue';
import CrossIcon from '~/components/Common/Svg/CrossIcon.vue';
import slugRouteName from '~/mixins/slugRouteName';

export default {
  name: 'AppHeader',
  components: { ApplyButton, LogoIcon, MenuIcon, CrossIcon },
  mixins: [slugRouteName],
  props: {
    headerScrollVariant: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      mobileMenuOpened: false,
      scrollTop: 0,
      scrollBottom: 0,
    };
  },
  computed: {
    scrollVariant() {
      if (
        ['privacy', 'cookie-policy', 'accessibility-statement'].includes(
          this.$route.name
        )
      ) {
        return true;
      }
      const scrollPercent = (this.scrollTop / this.scrollBottom) * 100;

      return scrollPercent > 0;
    },
    grayScrollVariant() {
      return ['journal', 'index'].includes(this.$route.name);
    },
    grayVariant() {
      return ['article-slug'].includes(this.$route.name);
    },
    darkIcon() {
      return (
        (this.scrollVariant ||
          this.headerScrollVariant ||
          this.grayVariant ||
          this.grayScrollVariant) &&
        !this.mobileMenuOpened
      );
    },
  },
  watch: {
    $route() {
      this.mobileMenuOpened = false;
    },
    mobileMenuOpened(mobileMenuOpened) {
      if (mobileMenuOpened) {
        document.querySelector('body').classList.add('body-noscroll');
      } else {
        document.querySelector('body').classList.remove('body-noscroll');
      }
    },
  },
  mounted() {
    this.onScroll();
    document.querySelector('body').classList.remove('body-noscroll');
    document.addEventListener('scroll', this.onScroll);
  },
  beforeUnmount() {
    document.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    onScroll() {
      this.scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;

      this.scrollBottom =
        (document.documentElement.scrollHeight || document.body.scrollHeight) -
        document.documentElement.clientHeight;
    },
    toggleMenu() {
      this.mobileMenuOpened = !this.mobileMenuOpened;
    },
    closeMenuOnNavigatingSameScreen(navigateTo) {
      if (this.mobileMenuOpened && navigateTo === this.$route.name) {
        this.mobileMenuOpened = false;
      }
    },
    onLoginClick() {
      this.$analytics.track('CTA Clicked', {
        cta_name: 'Log In',
        page_name: this.pageName,
        section: 'top-nav',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './AppHeader.scss';
</style>
